import { ErrorSource, trackRuntimeError, Observable } from '@datadog/browser-core';
import { StatusType } from '../../logger';
export function startRuntimeErrorCollection(configuration, lifeCycle, rawErrorObservable) {
    if (rawErrorObservable === void 0) { rawErrorObservable = new Observable(); }
    if (configuration.forwardErrorsToLogs) {
        trackRuntimeError(rawErrorObservable);
    }
    var rawErrorSubscription = rawErrorObservable.subscribe(function (rawError) {
        lifeCycle.notify(0 /* RAW_LOG_COLLECTED */, {
            rawLogsEvent: {
                message: rawError.message,
                date: rawError.startClocks.timeStamp,
                error: {
                    kind: rawError.type,
                    origin: ErrorSource.SOURCE,
                    stack: rawError.stack,
                },
                origin: ErrorSource.SOURCE,
                status: StatusType.error,
            },
        });
    });
    return {
        stop: function () {
            rawErrorSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=runtimeErrorCollection.js.map